module.exports = __webpack_public_path__ + "img/logo-m2n.759ea539.svg";